import { Button, Form, Input, Modal, message } from "antd";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { apiRequest } from "../../utils/apiClient";

const Add = ({
  isAddModalOpen,
  setIsAddModalOpen,
  categories,
  setCategories,
}) => {
  const { t } = useTranslation("pages");
  const [form] = Form.useForm();
  const user = useSelector((state) => state.user);

  const onFinish = async (value) => {
    try {
      const payload = { ...value };
      const effectiveBranchId = user?.branchId || user?.selectedBranchId;
      if (effectiveBranchId) payload.branchId = effectiveBranchId;
      const res = await apiRequest("/api/categories/add-category", {
        method: "POST",
        body: JSON.stringify(payload),
      });

      message.success(t("categoryAddedSuccess"));
      setIsAddModalOpen(false);
      form.resetFields();

      if (res?.category?._id) {
        setCategories([...categories, res.category]);
      } else {
        const url = effectiveBranchId
          ? `/api/categories/get-all?branchId=${encodeURIComponent(effectiveBranchId)}`
          : "/api/categories/get-all";
        const fresh = await apiRequest(url);
        setCategories(Array.isArray(fresh) ? fresh : categories);
      }

      // Notify product list / other listeners to refresh any derived UI.
      window.dispatchEvent(
        new CustomEvent("categoryChanged", {
          detail: { type: "added", title: value.title },
        })
      );
    } catch (error) {
      console.log(error);
      message.error(error?.message || t("failedToAddCategory"));
    }
  };

  return (
    <Modal
      title={t("addNewCategory")}
      open={isAddModalOpen}
      onCancel={() => setIsAddModalOpen(false)}
      footer={false}
    >
      <Form layout="vertical" onFinish={onFinish} form={form}>
        <Form.Item
          label={t("addCategory")}
          name="title"
          rules={[{ required: true, message: t("fieldRequired") }]}
        >
          <Input placeholder={t("enterCategoryName")} />
        </Form.Item>

        <Form.Item className="flex justify-end mb-0">
          <Button type="primary" htmlType="submit">
            {t("create")}
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default Add;
